import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "design-react-kit";

import logo from "../../assets/logo.svg";
import errorLogo from "../../assets/errors.svg";

import classes from "../../assets/LoginForm.module.css";
import FormsFooter from "../../components/FormsFooter";

const GeneralErrors = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <div className={classes["login-wrapper"]}>
        <div className={classes["left-side"]}>
          <img src={logo} alt="Logo" />
        </div>
        <div className={classes["right-side"]}>
          <div
            className={`d-flex flex-column align-items-center justify-content-center mx-auto ${classes.errorRight}`}
          >
            <img src={errorLogo} alt="Errors" />
            <h6 className="text-center">Attenzione!</h6>
            <h6 className="text-center">Il link usato non è più valido</h6>
            <p className={`w-50 ${classes.paragraph}`}>
              Il link utilizzato è scaduto e non più funzionante. Torna al login
              e ripeti la procedura.
            </p>
            <Button
              color="primary"
              className="change-password-btn"
              onClick={(e) => navigate("/")}
            >
              Vai al login
            </Button>
          </div>
          <FormsFooter classes={classes} />
        </div>
      </div>
    </Fragment>
  );
};

export default GeneralErrors;
